import React, {Component} from 'react';
import LabeledInput from './../../components/labeled-input'
import './index.css';

import {
    Form, Icon, Input, Button, Checkbox,
} from 'antd';


function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default class SetPasswordForm extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.email !== this.props.email) {
            this.props.form.setFieldsValue({ email: this.props.email });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });


        this.props.onSubmit(e);
    };

    handleChange = (event) => {
        //this.setState({[event.target.name]: event.target.value});
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {userId = "", password = "", rememberMe = ""} = this.props.credentials;
        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('email', {
                        rules: [
                            {required: true, message: 'Ange e-post'}],
                        initialValue: this.props.email
                    })(
                        <LabeledInput labelKey={'email'}
                                      prefix={<Icon type="user" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                      handleChange={this.handleChange} disabled/>
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('password', {
                        rules: [{required: true, message: 'Vänligen ange lösenord'}],
                        initialValue: ""
                    })(
                        <LabeledInput labelKey={'password'}
                                      prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                      type="password"
                                      handleChange={this.handleChange}/>
                    )}
                </Form.Item>

                <Form.Item>
                    {getFieldDecorator('confirmPassword', {
                        rules: [{required: true, message: 'Vänligen bekräfta lösenord'}],
                        initialValue: ""
                    })(
                        <LabeledInput labelKey={'passwordConfirmation'}
                                      prefix={<Icon type="lock" style={{color: 'rgba(0,0,0,.25)'}}/>}
                                      type="password"
                                      handleChange={this.handleChange}/>
                    )}
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Bekräfta
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}